module.exports = __webpack_public_path__ + "img/paseo.543eb9df.jpg";